import { Link, Grid, Typography, Paper, Button } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { createPopup } from '@typeform/embed';
import '@typeform/embed/build/css/popup.css';

const { toggle } = createPopup('qXnRr9dp');

const Benefits = (props) => {
  return (
    <Paper
      elevation={20}
      sx={{
        padding: { xs: '2rem', md: '4rem' },
        mt: '6rem',
        borderRadius: 5,
        textAlign: 'center',
        maxWidth: { xs: '100%', md: '50%' },
        mx: 'auto',
      }}>
      <Typography
        variant='h6'
        sx={{
          fontWeight: 'bold',
          textAlign: 'center',
          color: 'secondary.main',
          mb: '1rem',
        }}>
        BENEFITS
      </Typography>
      <Typography variant='h5' component='h2' sx={{ mt: '1rem' }}>
        <s>$250/month</s>
      </Typography>
      <Typography variant='h3' component='h2' sx={{ fontWeight: 'bold', mt: '1rem' }}>
        $100/month
      </Typography>
      <Typography variant='subtitle1' sx={{ fontWeight: 'bold', mt: '1rem' }}>
        Discount only for the first 20 people out of the 100.
      </Typography>
      <Grid container spacing={0} direction='column' alignItems='center' justifyContent='center'>
        {' '}
        <List sx={{ maxWidth: { xs: '100%', sm: '100%' } }}>
          <ListItem>
            <ListItemIcon>
              <CheckCircleIcon />
            </ListItemIcon>
            <ListItemText primary='Access to a private Slack community of 100 SaaS Founders in your specific niche' />
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <CheckCircleIcon />
            </ListItemIcon>
            <ListItemText primary='Matched into a hyper-curated mastermind of 4-8 SaaS Founders which meets once every month, with guidance by an executive coach' />
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <CheckCircleIcon />
            </ListItemIcon>
            <ListItemText primary='Membership card to get exclusive deals with our partners' />
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <CheckCircleIcon />
            </ListItemIcon>
            <ListItemText primary='Guest speakers who are powerhouses in their respective fields' />
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <CheckCircleIcon />
            </ListItemIcon>
            <ListItemText primary='Biweekly teh peng chats, for 1-1 personal connections' />
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <CheckCircleIcon />
            </ListItemIcon>
            <ListItemText primary='Monthly dinners, for 10 SaaS Founders to engage casually' />
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <CheckCircleIcon />
            </ListItemIcon>
            <ListItemText primary='Quarterly networking events, for 100 SaaS Founders to connect broadly' />
          </ListItem>
        </List>
      </Grid>

      <Link
        key={1}
        onClick={toggle}
        sx={{
          textDecoration: 'none',
        }}>
        <Button variant='contained' sx={{ mt: '1rem' }}>
          Join the waitlist (Limited Slots)
        </Button>
      </Link>
    </Paper>
  );
};

export default Benefits;
